module.exports = __webpack_public_path__ + "static/media/sf-trial-2.c9389a86.mp3";